import React from 'react';
import PropTypes from 'prop-types';
import MaterialDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledDrawer = styled(MaterialDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: 400,
    padding: 0,
    overflowX: 'hidden',
    backgroundColor: getPageBackgroundColor(theme)
  }
}));

/*
  Used to delay render of material drawer so that transition is visible.
  Need to do this since we are rendering this inside the modal portal.
*/
const useDelayRender = () => {
  const [ready, setReady] = React.useState(false);
  setTimeout(() => {
    setReady(true);
  }, 1);

  return ready;
};

const Drawer = ({ children, anchor, handleClose }) => {
  const ready = useDelayRender();
  return (
    <StyledDrawer anchor={anchor} open={ready} onClose={handleClose}>
      <Box position="relative" height="100%" width="100%">
        {children}
      </Box>
    </StyledDrawer>
  );
};

Drawer.defaultProps = {
  anchor: 'right',
  isOpen: false
};

Drawer.propTypes = {
  anchor: PropTypes.string,
  handleClose: PropTypes.func,
  children: CHILDREN_PROP_TYPES.isRequired
};

export default Drawer;
